export const CLIENT_PROFILE = 'CLIENT_PROFILE';
export const COACH_PROFILE = 'COACH_PROFILE';
export const CANDIDATE_PROFILE = 'CANDIDATE_PROFILE';
export const REFERRAL_PROFILE = 'REFERRAL_PROFILE';
export const CREATE_NEW_CANDIDATE = 'CREATE_NEW_CANDIDATE';
export const SHARE_OPTAVIA_PLAN = 'SHARE_OPTAVIA_PLAN';
export const EDGE365CHALLENGESCREEN = 'EDGE365CHALLENGESCREEN';
